import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconForum = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M27.8,16.5h-2.3V9.8c0-0.6-0.5-1.1-1.1-1.1h-2.3V2c0-0.6-0.5-1.1-1.1-1.1H2.1C1.5,0.9,1,1.4,1,2v6.7
			c0,0.6,0.5,1.1,1.1,1.1h2.3v6.7c0,0.6,0.5,1.1,1.1,1.1h2.3v6.7c0,0.6,0.5,1.1,1.1,1.1h2.3v3.9l3.9-3.9h12.8c0.6,0,1.1-0.5,1.1-1.1
			v-6.7C28.9,17,28.4,16.5,27.8,16.5z M2.1,8.7V2h19v6.7H8l-2.5,2.5V8.7H2.1z M5.5,16.5v-3.9l2.8-2.8h16.1v6.7H11.3L8.8,19v-2.5H5.5
			z M27.8,24.3H14.7l-2.5,2.5v-2.5H8.8v-3.9l2.8-2.8h16.2V24.3z"/>
        </g>
      </g>
    </SvgIcon>
  );
};

IconForum.displayName = 'IconForum';
IconForum.muiName = 'SvgIcon';

export default IconForum;



// WEBPACK FOOTER //
// ./src/components/Icons/IconForum.js